<template>
  <page>
    <div :load="doInit">
                <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Selection Criteria
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <form>
            <message :messages="messages"></message>
              <!-- filters -->
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('branch')" :data-vv-as="labels.branch" data-vv-name="branch" append-icon="mdi-magnify" @click:append="doHelplist('branch')" readonly v-validate="'required'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox v-model="form.includePartMatchTrans" :label="labels.includePartMatchTrans" data-vv-name="includePartMatchTrans" :data-vv-as="labels.includePartMatchTrans"></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :label="labels.transaction" :items="transactionList" v-model="form.transaction" item-text="value" item-value="code" data-vv-name="transaction" :data-vv-as="labels.transaction" :error-messages="errors.collect('transaction')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="form.tranType" :label="labels.tranType" :error-messages="errors.collect('tranType')" :data-vv-as="labels.tranType" data-vv-name="tranType" append-icon="mdi-magnify" @click:append="doHelplist('tranType')" readonly v-validate="'required'"></v-text-field>
                </v-flex>
              </v-layout>
              <!-- <v-divider class="mt-3 mb-3"></v-divider> -->
              <!-- intermediary -->
              <!-- <v-divider class="mt-3 mb-3"></v-divider> -->
              <!-- dates -->
            </v-container>
          </form>
        </v-card-text>
      </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-2"></v-spacer>
              <v-expansion-panels v-model="panel2" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-filter-variant</v-icon> Filter
                  </div>
                </v-expansion-panel-header>
                  <v-expansion-panel-content>
      <v-card>
        <v-card-text>
                      <v-container fluid grid-list-lg>
              <v-layout row wrap>
                      <v-flex md12 xs12>
                        <v-checkbox v-model="form.option1" :label="labels.option1" :error-messages="errors.collect('option1')" data-vv-name="option1" :data-vv-as="labels.option1" hide-details @change="toggelCheck('option1')"></v-checkbox>
                      </v-flex>
                      <v-flex xs6 md6>
                        <v-text-field :disabled="(form.option1 === false || form.option2 === true || form.option3 === true)" v-model="form.interFrom" :label="labels.interFrom" :error-messages="errors.collect('interFrom')" :data-vv-as="labels.interFrom" data-vv-name="interFrom" append-icon="mdi-magnify" @click:append="doHelplist('interFrom')" v-validate="toRequired"></v-text-field>
                      </v-flex>
                      <v-flex xs6 md6>
                        <v-text-field :disabled="(form.option1 === false || form.option2 === true || form.option3 === true)" v-model="form.interTo" :label="labels.interTo" :error-messages="errors.collect('interTo')" :data-vv-as="labels.interTo" data-vv-name="interTo" append-icon="mdi-magnify" @click:append="doHelplist('interTo')" v-validate="toDateValidation"></v-text-field>
                      </v-flex>
                      <v-flex md12 xs12>
                        <v-checkbox v-model="form.option2" :label="labels.option2" :error-messages="errors.collect('option2')" data-vv-name="option2" :data-vv-as="labels.option2" hide-details @change="toggelCheck('option2')"></v-checkbox>
                        <v-flex md6 xs6>
                          <v-textarea :disabled="(form.option1 === true || form.option2 === false || form.option3 === true)" v-model="form.iGrp" :label="labels.interGrp" :error-messages="errors.collect('interGrp')" :data-vv-as="labels.interGrp" data-vv-name="interGrp" append-icon="mdi-magnify" @click:append="doHelplist('interGrp')" readonly :counter="1000" :rows="2"></v-textarea>
                        </v-flex>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-checkbox v-model="form.option3" :label="labels.option3" :error-messages="errors.collect('option3')" data-vv-name="option3" :data-vv-as="labels.option3" hide-details @change="toggelCheck('option3')"></v-checkbox>
                        <v-text-field :disabled="(form.option1 === true || form.option2 === true || form.option3 === false)" v-model="form.interType" :label="labels.interType" :error-messages="errors.collect('interType')" :data-vv-as="labels.interType" data-vv-name="interType" append-icon="mdi-magnify" @click:append="doHelplist('interType')" readonly></v-text-field>
                      </v-flex>
                    </v-layout>
            </v-container>
                          </v-card-text>
      </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-expansion-panels>
              <v-spacer class="mt-2"></v-spacer>
              <v-expansion-panels v-model="panel3" multiple>
              <v-expansion-panel expand :value="[true]">
                <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-filter-variant</v-icon> Date Range
                  </div>
                </v-expansion-panel-header>
                  <v-expansion-panel-content>
      <v-card>
        <v-card-text>
                  <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex md6 xs12>
                      <v-autocomplete :label="labels.selectBasedOn" :items="seBasOnList" v-model="form.selectBasedOn" item-text="value" item-value="code" data-vv-name="selectBasedOn" :data-vv-as="labels.selectBasedOn" :error-messages="errors.collect('selectBasedOn')" v-validate="'required'"></v-autocomplete>
                    </v-flex>
                      <v-flex md6 xs12>
                        <div class="small font-weight-light grey--text">* Accounting Period - then Month/Year of Cut off date is used. </div>
                      </v-flex>
                      <v-flex xs6>
                      <cal-picker v-model="form.cutOffDate" :label="labels.cutOffDate" v-validate="'required|maxYear|minYear'" :data-vv-as="labels.cutOffDate" data-vv-name="cutOffDate" :error-messages="errors.collect('cutOffDate')"></cal-picker>
                    </v-flex>
                  </v-layout>
                  </v-container>
                          </v-card-text>
      </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-expansion-panels>
      <v-flex xs12>
        <v-checkbox v-model="form.rptParam" :label="labels.rptParam" :error-messages="errors.collect('rptParam')"
          data-vv-name="rptParam" :data-vv-as="labels.rptParam"></v-checkbox>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12>
        <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
          <v-icon left dark>mdi-file-export</v-icon>
          {{ labels.export }}
        </v-btn>
        <v-btn-toggle dense mandatory v-model="form.format">
          <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
            <span>{{ format.label }}</span>
            <v-icon :color="format.color">{{ format.icon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-flex>
      <v-dialog v-model="helplist" width="900px" persistent>
        <branch-help-list v-show="branchHelplist" :menu="menu" @close="doCloseHelpList" @doAssign="doAssign($event)"></branch-help-list>
        <tran-type-help-list v-show="tranTypeHelplist" :menu="menu" :transactionId="transactionId" @close="doCloseHelpList" @doAssign="doAssign($event)"></tran-type-help-list>
        <intermediary-helplist v-show="intermediaryFromHelplist" :menu="menu" @close="doCloseHelpList" @assignInterNoInfo="assignInterNoInfo($event)"></intermediary-helplist>
        <intermediary-helplist v-show="intermediaryToHelplist" :menu="menu" @close="doCloseHelpList" @assignInterNoInfo="assignInterNoInfo($event)"></intermediary-helplist>
        <inter-grp-helplist v-show="interGrpHelplist" :menu="menu" :valForm="valForm" @close="doCloseHelpList" @doAssign="doAssign($event)"></inter-grp-helplist>
        <inter-type-helplist v-show="interTypeHelplist" :menu="menu" :formVal="formVal" @close="doCloseHelpList" @doAssign="doAssign($event)"></inter-type-helplist>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { interGrpList } from './index'
import BranchHelpList from './helplist/BranchHelpList'
import TranTypeHelpList from './helplist/TranTypeHelpList'
import IntermediaryHelplist from './helplist/IntermediaryHelplist'
import InterGrpHelplist from './helplist/InterGrpHelplist'
import InterTypeHelplist from './helplist/InterTypeHelplist'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        branch: 'Branch',
        includePartMatchTrans: 'Include partially matched transactions',
        transaction: 'Type of Transaction',
        tranType: 'Transaction Type',
        option1: 'Option 1',
        interFrom: 'Intermediary No. From',
        interTo: 'Intermediary No. To',
        option2: 'Option 2',
        option3: 'Option 3',
        interGrp: 'Intermediary Group',
        interType: 'Intermediary Type',
        selectBasedOn: 'Select Based On',
        cutOffDate: 'Cut Off Date',
        rptParam: 'Print Runtime Parameters',
        export: 'Export To'
      },
      form: {
        branch: null,
        includePartMatchTrans: null,
        transaction: null,
        tranType: null,
        option1: null,
        interFrom: null,
        interTo: null,
        option2: null,
        interGrp: null,
        iGrp: null,
        option3: null,
        interType: null,
        selectBasedOn: null,
        cutOffDate: null,
        rptParam: true,
        format: null,
        sendEmail: false
      },
      transactionList: [
        { code: 'AL', value: 'All Transactions' },
        { code: 'AT', value: 'Account Transactions' },
        { code: 'UT', value: 'Underwriting Transactions' },
        { code: 'CT', value: 'Claim Transactions' }
      ],
      seBasOnList: [
        { code: 'TD', value: 'Transaction Date' },
        { code: 'AP', value: 'Accounting Period' }
      ],
      toggleFilters: [true],
      menu: {},
      transactionId: null,
      valForm: null,
      formVal: null,
      supportedFormat: [],
      submitting: false,
      helplist: false,
      branchHelplist: false,
      tranTypeHelplist: false,
      intermediaryFromHelplist: false,
      intermediaryToHelplist: false,
      interGrpHelplist: false,
      interTypeHelplist: false,
      rptHistory: false,
      getCode: null,
      panel1: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    toDateValidation() {
      if (this.form.option1 === true && this.form.interFrom !== '' && this.form.interFrom !== null) {
        return 'required|valToNo:' + this.form.interFrom
      } else {
        return ''
      }
    },
    toRequired() {
      if (this.form.option1 === true) {
        return 'required'
      } else {
        return ''
      }
    },
    getCodeValue() {
      return this.interGrpList.filter((list) => {
        for (let ig in this.getCode) {
          if (this.getCode[ig] === list.code) {
            return list
          }
        }
      })
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    },
    'form.transaction': function(valNew) {
      const newVal = valNew.toString()
      if (newVal === 'AL') {
        // For All Transactions
        this.transactionId = this.form.transaction
      } else if (newVal === 'AT') {
        // For Account Transactions
        this.transactionId = this.form.transaction
      } else if (newVal === 'UT') {
        // For Underwriting Transactions
        this.transactionId = this.form.transaction
      } else if (newVal === 'CT') {
        // For Claims Transactions
        this.transactionId = this.form.transaction
      } else {
        this.transactionId = ''
      }
      this.form.tranType = ''
    },
    'form.option1': function(va) {
      if (this.form.option1 === false) {
        this.resetValidator()
        this.form.interFrom = ''
        this.form.interTo = ''
      }
    },
    'form.option2': function(val) {
      if (this.form.option2 === true) {
        this.form.interGrp = 'All'
        this.form.iGrp = 'All'
      } else {
        this.form.interGrp = ''
        this.form.iGrp = ''
      }
      this.valForm = this.form.iGrp
    },
    'form.option3': function(vale) {
      if (this.form.option3 === true) {
        this.form.interType = 'All'
      } else {
        this.form.interType = ''
      }
      this.formVal = this.form.interType
    },
    'form.interTo': function(valu) {
      if (this.form.interTo !== '') {
        this.$validator.validate('interTo')
      }
    },
    'form.interFrom': function(valu) {
      if (this.form.interFrom !== '') {
        this.$validator.validate('interFrom')
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.unMatchedAcctTrans
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
            if (this.menu) {
              this.form.branch = 'All'
              this.form.tranType = 'All'
              this.form.transaction = 'AL'
              this.form.includePartMatchTrans = false
              this.form.option1 = false
              this.form.interFrom = null
              this.form.interTo = null
              this.form.option2 = false
              this.form.interGrp = null
              this.form.iGrp = null
              this.form.option3 = false
              this.form.interType = null
              this.form.selectBasedOn = 'TD'
              this.form.cutOffDate = removeTime(Date.now())
              this.form.rptParam = true
              this.form.sendEmail = false
              this.disabledFrom = true
              this.getCode = null
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    toggelCheck(field) {
      switch (field) {
        case 'option1': {
          this.form.option2 = false
          this.form.option3 = false
          break
        }
        case 'option2': {
          this.form.option1 = false
          this.form.option3 = false
          break
        }
        case 'option3': {
          this.form.option1 = false
          this.form.option2 = false
          break
        }
        default: {
          this.form.option1 = false
          this.form.option2 = false
          this.form.option3 = false
          break
        }
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.form.option1 === false && this.form.option2 === false && this.form.option3 === false) {
            this.$toast.error('Must check one option.')
          } else {
            this.processExport()
          }
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doHelplist(field) {
      this.helplist = true
      switch (field) {
        case 'branch': {
          this.branchHelplist = true
          break
        }
        case 'tranType': {
          this.tranTypeHelplist = true
          break
        }
        case 'interFrom': {
          this.intermediaryFromHelplist = true
          break
        }
        case 'interTo': {
          this.intermediaryToHelplist = true
          break
        }
        case 'interGrp': {
          this.interGrpHelplist = true
          break
        }
        case 'interType': {
          this.interTypeHelplist = true
          break
        }
        default: {
          this.helplist = false
          this.branchHelplist = false
          break
        }
      }
    },
    doAssign(data) {
      if (this.branchHelplist) {
        this.form.branch = []
        this.form.branch = data.finalSelectedItems.toString()
      }
      if (this.tranTypeHelplist) {
        this.form.tranType = []
        this.form.tranType = data.finalSelectedItems.toString()
      }
      if (this.interGrpHelplist) {
        this.form.interGrp = []
        this.form.iGrp = []
        this.form.interGrp = data.finalSelectedItems.toString()
        this.getCode = data.finalSelectedItems
        if (this.getCodeValue.length > 0) {
          for (let gt in this.getCodeValue) {
            this.form.iGrp += this.getCodeValue[gt].codeValue + ','
          }
          this.form.iGrp = this.form.iGrp.slice(0, -1)
        } else {
          this.form.iGrp = data.finalSelectedItems.toString()
        }
      }
      if (this.interTypeHelplist) {
        this.form.interType = []
        this.form.interType = data.finalSelectedItems.toString()
      }
      this.helplist = false
      this.branchHelplist = false
      this.tranTypeHelplist = false
      this.intermediaryFromHelplist = false
      this.intermediaryToHelplist = false
      this.interGrpHelplist = false
      this.interTypeHelplist = false
    },
    assignInterNoInfo(data) {
      if (this.intermediaryFromHelplist) {
        this.form.interFrom = ''
        this.form.interFrom = data.inter
      }
      if (this.intermediaryToHelplist) {
        this.form.interTo = ''
        this.form.interTo = data.inter
      }
      this.helplist = false
      this.intermediaryFromHelplist = false
      this.intermediaryToHelplist = false
    },
    doCloseHelpList(rptKey) {
      this.helplist = false
      this.branchHelplist = false
      this.tranTypeHelplist = false
      this.intermediaryFromHelplist = false
      this.intermediaryToHelplist = false
      this.interGrpHelplist = false
      this.interTypeHelplist = false
    }
  },
  created() {
    this.doInit()
    this.interGrpList = interGrpList

    this.$validator.extend('maxYear', {
      getMessage(field, args) {
        return 'You are selecting more than 10 years from now.'
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tenYears = new Date(today)
          tenYears.setFullYear(tenYears.getFullYear() + 10)
          const startDate = removeTime(value)
          // if (isAfter(today, startDate)) return false
          // else return true
          return (isAfter(tenYears, startDate))
        } else return true
      }
    })

    this.$validator.extend('minYear', {
      getMessage(field, args) {
        return 'You are selecting a date in the last century.'
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const lessThan2000 = new Date(today)
          lessThan2000.setFullYear(2000)
          const startDate = removeTime(value)
          return (startDate.getFullYear() >= lessThan2000.getFullYear())
        } else return true
      }
    })

    this.$validator.extend('valToNo', {
      getMessage(field, args) {
        return 'To Intermediary No. must be equal or greater than From Intermediary No.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var valNo = args[0]
        if (valNo) {
          return (value >= valNo)
        }
      }
    })
  },
  components: {
    BranchHelpList,
    TranTypeHelpList,
    IntermediaryHelplist,
    InterGrpHelplist,
    InterTypeHelplist
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ]
}
</script>

<style>
</style>
